import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    search = '',
    pi = 1,
    ps = 50,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.myOrgDep.getPage, {
        search,
        pi,
        ps,
    }, options);
    if (error) return { error, status };
    return content || {};
};
